import React, { memo } from 'react';

import { IPositionedEvent } from '~/Screens/Calendar/interfaces';
import { PositionedEvent } from '~/Screens/Calendar/CalendarView/components';
import { makeStyles } from '~/UIKit/Style';
import { EVENT_Z_INDEX } from '~/Screens/Calendar/constants';

const useStyles = makeStyles(
  () => ({
    container: {
      zIndex: EVENT_Z_INDEX + 2,
      position: 'absolute',
    },
  }),
  { name: 'CreatingEvent' },
);

export const UpdatingEvent = memo(
  ({ top, eventData }: { top?: number; eventData: IPositionedEvent | null }) => {
    const { classes } = useStyles();

    if (!eventData) {
      return null;
    }
    const { position, event } = eventData;

    return (
      <div className={classes.container} style={{ top }}>
        <PositionedEvent event={event} position={position} isLoading />
      </div>
    );
  },
);
